import lazyLoading from './lazyLoading'

export default {
  name: 'finanzaporto',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [
    {
      name: 'pagos',
      path: '/pagos',
      component: lazyLoading('app/payments/PaymentListTab'),
      meta: {
        title: 'Consulta Pagos',
        requiresAuth: true
      }
    },
    {
      name: 'ticketsFinancialDeposits',
      path: '/financial/deposits',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Pagos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DepositList'),
          meta: {
            title: 'Pagos'
          }
        },
        {
          name: 'depositDetail',
          path: ':depositId',
          component: lazyLoading('financial/DepositDetail'),
          props: true,
          meta: {
            title: 'Detalle del Pago'
          }
        }
      ]
    },
    {
      name: 'clarificationTicket',
      path: '/utils/clarification-ticket',
      component: lazyLoading('tools/AssignTicket'),
      meta: {
        title: 'Aclaración de Boletos',
        requiresAuth: true
      }
    },
    {
      name: 'processDay',
      path: '/utils/process-day',
      component: lazyLoading('tools/ProcessDay'),
      meta: {
        title: 'Proceso del Día',
        requiresAuth: true
      }
    },
    {
      name: 'processWeek',
      path: '/utils/process-week',
      component: lazyLoading('tools/ProcessWeek'),
      meta: {
        title: 'Proceso Semanal',
        requiresAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/finanzaporto.js